export const LEARN_DASHBOARD_PAGE_NAME = 'Learn Dashboard';
export const LEARN_DASHBOARD_PAGE_KEY = 'homepage';

/**
 * NOTA: Organizaciones con el home oculto de forma temporal.
 * Había bugs de data en esta vista para Diltex.
 * Se acordó ocultar este home hasta retomar la migración del home antiguo de learning.
 */
export const LEARN_HOME_REDIRECT_ORGANIZATION_SLUGS = [
  'universidad-diltex',
  'qa-corp-child1', // qa
  'org-agt', // qa
];

export const APP_ID = 'mevliu65';
export const APP_ID_QA = 'if08s3kq';

export enum LEARN_DASHBOARD_FEATURE_FLAGS {
  LEARNING_FOUNDATION_LIDER = 'LEARNING_FOUNDATION_LIDER',
  NEW_SIDEBAR_LAYOUT = 'NEW_SIDEBAR_LAYOUT',
  USER_NOTIFICATION_WEB = 'user_notification_web',
}
